import api from './../utils/api';


export const getSimilarProducts = async (productId) => {
  try {
    const response = await api.get(`/recommend/similar-products/${productId}`,
      {
        withCredentials: true
      }
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getPinnedProducts = async (limit) => {
  try {
    const response = await api.get(`/recommend/pinned-products?limit=${limit}`,
      {
        withCredentials: true
      }
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};